import React from 'react';
import { useQuery } from '@apollo/client';
import { organizationAdminDetailsByIdQuery } from '../../graphql/queries';
import { LoadingSpinner, ErrorDisplay } from '../LoadingStates';
import BasicInfo from './BasicInfo';
import OrganizationSection from './OrganizationSection';
import RatesSection from './RatesSection';
import OnboardingsSection from './OnboardingsSection';
import { Box } from '@mui/material';

interface OrganizationAdminDetailsProps {
  organizationAdminId: number;
}

export default function OrganizationAdminDetails({
  organizationAdminId,
}: OrganizationAdminDetailsProps) {
  const { data, loading, error } = useQuery(organizationAdminDetailsByIdQuery, {
    variables: { id: organizationAdminId },
  });

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorDisplay error={error} />;
  }

  const organizationAdmin = data?.organizationAdminById;

  if (!organizationAdmin) {
    return <ErrorDisplay error="Organization admin not found" />;
  }

  return (
    <>
      <Box mb={2}>
        <BasicInfo organizationAdmin={organizationAdmin} />
      </Box>
      <OrganizationSection organizationAdmin={organizationAdmin} />
      <RatesSection organizationAdmin={organizationAdmin} />
      <OnboardingsSection organizationAdmin={organizationAdmin} />
    </>
  );
}
